import { Br } from "@/components/molecules/Br";
import Image from "next/image";
import coverServiceSP from "/public/cover-ServicesSP.svg";
import coverServiceTOP from "/public/cover-ServicesTOP.svg";
import leadService from "/public/lead-services.svg";

export const ServiceCover = (props) => {
  return (
    <>
      <div className="relative mx-auto  box-border  aspect-2/1 max-w-7xl bg-white p-0 md:aspect-1.91/1">
        <div className="absolute top-1/2 left-1/2 z-10 flex w-full -translate-y-1/2 -translate-x-1/2 flex-col items-start justify-start 2xs:max-w-[236px] 2xs:gap-2 xs:max-w-[272px] xs:gap-2 md:max-w-md md:gap-3 lg:max-w-3xl lg:gap-6">
          <h2 className="relative aspect-3.88/1 w-auto fluid-height-[38px,108px]">
            <Image
              src={leadService}
              alt="ToccaSystems's Service"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </h2>
          <div className="text-left font-bold text-pri 2xs:space-y-2 xs:space-y-2">
            <h3 className="fluid-text-[16px,26px]">Services of ToccaSystems</h3>
            <h5 className="leading-relaxed text-ter fluid-text-[11px,18px] 2xs:leading-tight xs:leading-snug sm:leading-normal md:leading-comfort">
              ビジネスの在り方は、一つとして同じではありません。
              <Br pc />
              私たちのサービスは、クライアントの成長をサポートするシステムを構築し、企業価値を共に創るお手伝いをすることです。
            </h5>
          </div>
        </div>
        <div className="relative z-0 mx-auto box-border flex aspect-1.4/1 w-full items-center justify-center md:aspect-1.91/1 ">
          <span className="hidden md:block">
            <Image
              src={coverServiceTOP}
              alt="Contracted Development / Solution Profile / WEB Development Map / Consulting / Package"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
          <span className="block md:hidden">
            <Image
              src={coverServiceSP}
              alt="Contracted Development / Solution Profile / WEB Development Map / Consulting / Package"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
        </div>
      </div>
    </>
  );
};
export const ServiceCoverTop = (props) => {
  return (
    <>
      <div className="relative mx-auto box-border aspect-1.91/1 max-w-7xl bg-white">
        <div
          className="absolute
        top-1/2
        left-1/2
        z-10
        flex
        w-full
        -translate-y-1/2
        -translate-x-1/2
        flex-col
        items-start
        justify-start
        gap-3
        2xs:max-w-[275px]
        xs:max-w-[300px]
        sm:max-w-[500px]
        md:max-w-md
        lg:max-w-3xl
        lg:gap-6
        xl:max-w-3xl"
        >
          <h2
            className="relative
          aspect-3.88/1
          h-[48px]
          w-auto
          xs:h-[56px]
          sm:h-[72px]
          md:h-[80px]
          lg:h-[96px]
          xl:h-[108px]"
          >
            <Image
              src={leadService}
              alt="ToccaSystems's Service"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </h2>
          <div className="space-y-2 text-left font-bold">
            <h3 className="text-sec fluid-text-[14px,26px]">
              Services of ToccaSystems
            </h3>
            <h5 className="leading-relaxed text-ter fluid-text-[12px,18px] 2xs:leading-snug xs:leading-snug sm:leading-normal md:leading-comfort">
              ビジネスの在り方は、一つとして同じではありません。
              <br className="br_sm" />
              <Br pc />
              私たちのサービスは、クライアントの成長をサポートするシステムを構築し、
              <br className="br_sm" />
              企業価値を共に創るお手伝いをすることです。
            </h5>
          </div>
        </div>
        <div className="relative z-0 mx-auto flex aspect-1.4/1 w-full items-center justify-center sm:aspect-1.91/1">
          <span className="hidden sm:block">
            <Image
              src={coverServiceTOP}
              alt="Contracted Development / Solution Profile / WEB Development Map / Consulting / Package"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
          <span className="block sm:hidden">
            <Image
              src={coverServiceSP}
              alt="Contracted Development / Solution Profile / WEB Development Map / Consulting / Package"
              quality={80}
              layout="fill"
              objectFit="cover"
            />
          </span>
        </div>
      </div>
    </>
  );
};
